import React from "react";

// Real client logos hosted locally, rendered as monochrome teal via CSS mask-image.
// The mask uses each logo's alpha channel to paint a uniform teal fill.
const clients = [
  { name: "IBM", file: "/logos/ibm.svg" },
  { name: "SARS", file: "/logos/sars.png" },
  { name: "Transnet", file: "/logos/transnet.png" },
  { name: "Standard Bank", file: "/logos/standardbank.svg" },
  { name: "Absa", file: "/logos/absa.svg" },
  { name: "MTN", file: "/logos/mtn.svg" }
];

export default function ClientsStrip() {
  return (
    <section className="py-16 border-y border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center text-[12px] uppercase tracking-[0.22em] text-slate-500">
          Trusted by enterprise teams across Southern Africa
        </div>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-10 items-center">
          {clients.map((c) => (
            <div
              key={c.name}
              title={c.name}
              className="flex items-center justify-center h-14 group"
            >
              <div
                role="img"
                aria-label={`${c.name} logo`}
                className="logo-mono w-full h-full max-w-[150px]"
                style={{
                  WebkitMaskImage: `url(${c.file})`,
                  maskImage: `url(${c.file})`
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
